import { useEffect, useRef } from "react";
import loca_log from "../assets/logo.png";

const { kakao } = window;

function Location() {
  const mapRef = useRef(null);
  useEffect(() => {
    const container = mapRef.current;
    let options = {
      center: new kakao.maps.LatLng(37.52289, 126.9021),
      level: 4,
    };
    let map = new kakao.maps.Map(container, options);

    let markerPosition = new kakao.maps.LatLng(37.52289, 126.9021);
    let marker = new kakao.maps.Marker({
      position: markerPosition,
    });
    marker.setMap(map);
  }, []);

  return (
    <div className="wrap">
      <section className="sec-wrap">
        <section className="sec-centent">
          <div id="sub" className="contactus">
            <div className="cont-wr">
              <div className="wr">
                <div className="cont-tit">
                  <h2 className="big">Contact Us</h2>
                </div>
                <div className="con-tab active" data-id="con-tab1">
                  <div className="map" ref={mapRef}></div>
                  <div className="map-info">
                    <div className="tplat-logo">
                      <img src={loca_log} alt="회사로고" />
                      <span className="sr-only">JENIX</span>
                    </div>
                    <ul className="info-list">
                      <li>
                        <strong className="tit">Address</strong>
                        <span className="det">서울시 영등포구 영신로 166 반도아이비밸리 413호</span>
                      </li>
                      <li>
                        <strong className="tit">Tel</strong>
                        <span className="det">&nbsp;02-861-4716</span>
                      </li>
                      <li>
                        <strong className="tit">Email</strong>
                        <span className="det">&nbsp;kissis@jenixinfo.co.kr</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}

export default Location;
